import React from 'react';
import { useFormikContext } from 'formik';
import { Grid } from '@material-ui/core';

import { useRouteHelper } from 'core/hooks/use-route-helper';
import { tooltipHoverTexts } from 'core/helpers/constants';
import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import RemoveLockedButton from 'core/components/remove-locked-button';
import { getPersonAge } from '../helpers';
import useSession from 'core/hooks/use-session';
import useStyles from './household-residents.styles';

const Resident = ({ item = {}, index }) => {
  const classes = useStyles(index);
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const { isAgency } = useSession();
  const { inOfferEditRoute } = useRouteHelper();

  const removePipResidents = (id) => {
    setFieldValue(
      'nonDrivers',
      values?.nonDrivers?.filter((resident) => resident?.id !== id)
    );
    setFieldTouched('nonDrivers', true);
  };

  const isDriver = values.drivers.some((driver) => driver.id === item?.id);
  const isPrimary = isDriver && item?.isPrimary;

  // we only show tool tips for drivers and primary applicants
  const isDriverOrPrimaryTip = isPrimary
    ? tooltipHoverTexts?.pipCantRemoveApplicant
    : tooltipHoverTexts?.pipCantRemoveDriver;

  return (
    <Grid item className={classes.residentInformation}>
      <Grid item className={classes.nameAndAge}>
        <Label type="darkGreenMedium" className={classes.residentName}>
          {item?.firstName?.toUpperCase()} {item?.lastName?.toUpperCase()}
        </Label>
        <Label type="body4" className={classes.residentAge}>
          {getPersonAge(item?.dateOfBirth)} YEARS
        </Label>
      </Grid>

      {isDriver || (isAgency && inOfferEditRoute) ? (
        <Grid item className={classes.trashContainer}>
          <Label type="green75small" className={classes.value}>
            {isDriver ? (isPrimary ? 'Primary applicant' : 'Driver on the policy') : 'Household resident'}
          </Label>
          <RemoveLockedButton
            mode="big"
            text={isAgency ? tooltipHoverTexts?.pipCantRemoveBecauseAgency : isDriverOrPrimaryTip}
          />
        </Grid>
      ) : (
        <Grid item className={classes.trashContainer}>
          <Label type="green75small" className={classes.value}>
            Other household resident
          </Label>
          <FormField
            type="remove"
            name="remove"
            permissions={{ isLicensedAction: true }}
            mode="big"
            onClick={() => removePipResidents(item?.id)}
            fast={false}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Resident;
